import { Filters } from "@/pages/SearchResult/SearchPage";

interface SRConsoleHeroProps {
    filters?: Filters;
    onSearchClick: () => void;
}

export default function SearchConsoleInput({ onSearchClick }: SRConsoleHeroProps) {
    return (
        <div className="sr-console-input" onClick={onSearchClick}>
            <div className="icon"><i className="fa-solid fa-magnifying-glass"></i></div>
            <div className="field-row">
                <label htmlFor="sr-input">Where shall we set sail?</label>
                <input
                    className="sr-input text-overflow"
                    type="text"
                    readOnly
                    id="sr-input"
                    placeholder="Start your charter journey"
                // value={currentFilters.destination?.map((x: string | { label: string }) => typeof x === 'string' ? x : x.label).join(', ') || ''}
                />
            </div>
        </div>
    );
}